function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "-5 -6 50 50",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "Layer1",
    name: "Layer 1",
    opacity: 1
  }, React.createElement("g", {
    id: "Shape1"
  }, React.createElement("path", {
    id: "shapePath1",
    d: "M35.525,31.228 L26.645,22.346 C28.089,20.108 28.943,17.451 28.943,14.594 C28.943,6.685 22.505,0.250999 14.597,0.250999 C6.686,0.250999 0.254,6.685 0.254,14.594 C0.254,22.505 6.687,28.938 14.597,28.938 C17.453,28.938 20.11,28.089 22.349,26.644 L31.229,35.524 C31.524,35.821 32.011,35.821 32.305,35.524 L35.525,32.303 C35.824,32.008 35.824,31.523 35.525,31.228 M4.81,14.593 C4.81,9.197 9.201,4.805 14.598,4.805 C19.996,4.805 24.385,9.197 24.385,14.593 C24.385,19.991 19.996,24.382 14.598,24.382 C9.2,24.382 4.81,19.991 4.81,14.593 Z",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.a5577421.svg";
export { ForwardRef as ReactComponent };